export default __webpack_public_path__ + "static/game-fe71a477708817583767d97d54070cce.png";